import { Claims } from "./enums/claims";

export class MenuBarItem {
    class?: string;
    icon?: string;
    items?: MenuBarItem[];
    label?: string;
    routerLink?: string[];
    styleClass?: string;
    url?: string; 
    claims?: Claims[];
    target?: string;
    visible?: boolean = true;
}